import * as React from 'react';

import SoundUsageHistoryList from '../../common/sound_usage_histories/partials/SoundUsageHistoryList';
import BottomNewSoundUsageHistoryButton from '../../common/sound_usage_histories/partials/BottomNewSoundUsageHistoryButton';
import BottomCreateSoundButton from './partials/BottomCreateSoundButton';
import NoSoundUsageHistories from '../../common/sound_usage_histories/partials/NoSoundUsageHistories';

import Layout from '../../../../shared/Layout';
import ResourceFavoriteListLink from '../../../../shared/ResourceFavoriteListLink';

import NavigationProp from '../../../../../navigators/NavigationProp';
import {
  SceneFormBackgroundMusicShowSceneCommandNewSoundUsageHistoriesRouteProp,
  SceneFormBackgroundMusicShowSceneCommandEditSoundUsageHistoriesRouteProp,
} from '../../../../../navigators/RouteProps';

import {Params as SoundUsageHistoryIndexParams} from '../../../../../actions/sound_usage_histories/index';

import redirectSceneForm from '../../../../../helpers/redirectSceneForm';

import SoundUsageHistory from '../../../../../../domain/entities/SoundUsageHistory';
import PaginatedResult from '../../../../../../domain/results/PaginatedResult';
import SceneForm from '../../../../../../domain/forms/SceneForm';
import Sound from '../../../../../../domain/entities/Sound';
import CurrentUser from '../../../../../../domain/entities/writer/CurrentUser';

import * as features from '../../../../../helpers/features';

export interface Params {
  storyId: number;
  episodeId?: number;
  sceneId?: number;
  sceneCommandIndex?: number;
  back?: boolean;
  parentSceneCommandId?: number;
}

export interface StateProps {
  navigation: NavigationProp;
  route:
    | SceneFormBackgroundMusicShowSceneCommandNewSoundUsageHistoriesRouteProp
    | SceneFormBackgroundMusicShowSceneCommandEditSoundUsageHistoriesRouteProp;
  sceneForm: SceneForm | null;
  soundUsageHistoriesParams: SoundUsageHistoryIndexParams;
  soundUsageHistories: SoundUsageHistory[] | null;
  currentUser: CurrentUser | null;
  enabledFavorite?: boolean;
}

export interface DispatchProps {
  indexSoundUsageHistories: (
    params: SoundUsageHistoryIndexParams,
  ) => Promise<PaginatedResult<SoundUsageHistory>>;
}

interface Props extends StateProps, DispatchProps {
  onSelectSoundUsageHistory: (soundUsageHistory: SoundUsageHistory) => void;
  onForwardToNewSoundUsageHistory: () => void;
  onForwardToFavoriteList?: () => void;
  onSelectSound: (sound: Sound) => void;
}

export default class Index extends React.Component<Props> {
  public componentDidMount() {
    const {
      navigation,
      route,
      sceneForm,
      soundUsageHistoriesParams,
      soundUsageHistories,
      indexSoundUsageHistories,
      onForwardToFavoriteList,
    } = this.props;
    if (redirectSceneForm(navigation, route, sceneForm)) {
      return;
    }
    if (!soundUsageHistories) {
      indexSoundUsageHistories(soundUsageHistoriesParams);
    }
  }

  public render(): React.ReactNode {
    const {
      route,
      navigation,
      soundUsageHistories,
      enabledFavorite,
      currentUser,
      onSelectSoundUsageHistory,
      onForwardToNewSoundUsageHistory,
      onForwardToFavoriteList,
      onSelectSound,
    } = this.props;

    const {storyId, back} = route.params;
    const enabledUploadSound = !!(
      features.enabledUploadSound &&
      (currentUser?.isGradeBlack() || currentUser?.enabledPaidSubscriber)
    );
    return (
      <Layout
        title={'BGM'}
        scrollable={false}
        back={back}
        navigation={navigation}
        close={true}>
        {soundUsageHistories ? (
          soundUsageHistories.length > 0 ? (
            <>
              <SoundUsageHistoryList
                soundUsageHistories={soundUsageHistories}
                onSelectSoundUsageHistory={onSelectSoundUsageHistory}
                onForwardToFavoriteList={
                  enabledFavorite ? onForwardToFavoriteList : undefined
                }
              />

              <BottomNewSoundUsageHistoryButton
                style={enabledUploadSound ? {paddingBottom: 80} : undefined}
                onPress={onForwardToNewSoundUsageHistory}
              />
              {enabledUploadSound && (
                <BottomCreateSoundButton
                  storyId={storyId}
                  onSelectSound={onSelectSound}
                />
              )}
            </>
          ) : (
            <>
              <NoSoundUsageHistories
                storyId={storyId}
                enabledUploadSound={enabledUploadSound}
                onForwardToNewSoundUsageHistory={
                  onForwardToNewSoundUsageHistory
                }
                onSelectSound={onSelectSound}
              />
              {enabledFavorite && (
                <ResourceFavoriteListLink
                  style={{position: 'absolute', top: 16, right: 16}}
                  onPress={onForwardToFavoriteList}
                />
              )}
            </>
          )
        ) : null}
      </Layout>
    );
  }
}
